export const EMPLOYEE_INDEX = 'employee-index';
export const CANDIDATE_INDEX = 'candidate-index';
export const CANDIDATE_SHOW = 'candidate-show';
export const TEMPLATE_SHOW = 'template-show';

export type OfferLetterCreationReferer =
    | typeof EMPLOYEE_INDEX
    | typeof CANDIDATE_INDEX
    | typeof CANDIDATE_SHOW
    | typeof TEMPLATE_SHOW;
